import { redirect } from '@tanstack/react-router';
import { toast } from 'sonner';
import { hasPermission, type Permission } from '@worldathletics/utilities';

import type { AuthUser } from '@/context/store/slices/authSlice';
import { editorStore } from '@/context/store/store';

type Role = AuthUser['role'];

export function requireAuth(): void {
  const status = editorStore.getState().auth.status;
  if (status !== 'authenticated') {
    throw redirect({ to: '/login' });
  }
}

export function requireRoles(roles: Role[]): void {
  const user = editorStore.getState().auth.user;
  if (!user || !roles.includes(user.role)) {
    toast.error("You don't have permission to access this page.");
    throw redirect({ to: '/documents' });
  }
}

export function requirePermission(permission: Permission): void {
  const role = editorStore.getState().auth.user?.role;
  if (!role || !hasPermission(role, permission)) {
    toast.error("You don't have permission to access this page.");
    throw redirect({ to: '/documents' });
  }
}
